import { CircularProgress } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import GuestGroupIcon from '@material-ui/icons/SupervisorAccountOutlined';
import WarningIcon from '@material-ui/icons/Warning';
import { Form } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { isUserWithoutEmail } from '../../_config/utils';
import * as GuestActions from '../../redux/actions/guest.actions';
import ListLoadingView from '../ListLoadingView.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import FormFlatContainer from './Elements/FormFlatContainer.jsx';
import SelectableField from './Fields/SelectableInput/SelectableField.jsx';
import InfoSection from '../InfoSection/InfoSection.jsx';


const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'required';
  }

  if (!values.type) {
    errors.type = 'required';
  }

  if (!values.color) {
    errors.color = 'required';
  }

  return errors;
};


@reduxForm({ form: 'TagGuestsForm', validate })
@connect(state => ({ form: state.form.TagGuestsForm }))
class TagGuestsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      guestsOptions: [],
      guestsSelected: null
    };
  }

  async componentDidMount() {
    this.onFetchGuestsAndSetOptions();
  }

  async onFilterGuests(value) {
    const { dispatch } = this.props;
    dispatch(GuestActions.setFilter('search', value));
    this.onFetchGuestsAndSetOptions();
  }
    
  async onFetchGuestsAndSetOptions() {
    const { dispatch, items } = this.props;
    const guests = await dispatch(GuestActions.fetchGuests());
    const guestOptions = _.map(guests, guest => ({ value: guest, label: `${guest.firstname} ${guest.lastname} ${isUserWithoutEmail(guest) ? '': ` - ${guest.email}`}` }));
    const filteredGuestsOptions = _.filter(guestOptions, guestOption => !_.find(items, { id: guestOption.value.id }));
    this.setState({ guestsOptions: filteredGuestsOptions });
    return filteredGuestsOptions;
  }
  
  onSelectGuest(guests) {
    this.setState({ guestsSelected: guests });
  }

  onAddGuestsToTag(guests) {
    const { onAddGuestsToTag } = this.props;
    onAddGuestsToTag(guests);
    this.setState({ guestsSelected: null });
  }

  render() {
    const { canAddGuests, isListLoading, onDownloadListCSV, items, rowElement, pagination, onFetchMoreItems } = this.props;
    const { guestsOptions, guestsSelected } = this.state;
    return (
      <Form>
        <FormFlatContainer
          title="guestWithinTag"
          subtitle="guestWithinTagDescription"
          icon={<GuestGroupIcon style={{ fontSize: 20, color: '#3f3f3f', marginTop: 0 }} />}
          containerStyle={{ marginRight: 10 }}
        >
          {canAddGuests ? (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Field
                name="guestTagSelectedSearch"
                component={SelectableField}
                noCache
                multi
                options={guestsOptions}
                placeholder={<Entity entity="findGuestToAdd" />}
                containerstyle={{ minWidth: 480, marginRight: 10 }}
                onInputChange={value => this.onFilterGuests(value)}
                onSelect={tagData => this.onSelectGuest(tagData)}
              />
              <MDButton
                disabled={!guestsSelected || !_.size(guestsSelected)}
                title={<Entity entity="addGuestToTag" />}
                style={{ borderRadius: 5 }}
                onClick={() => this.onAddGuestsToTag(guestsSelected)}
              />
              {isListLoading ? <CircularProgress /> : null}
            </div>
          ) : null}
          {!_.isEmpty(items) ? (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
              <SaveIcon style={{ marginRight: 5, fontSize: 20, color: '#90CAF9' }} />
              <h4 onClick={() => onDownloadListCSV()} className="label-responsive link-label"><Entity entity="downloadCSV" /></h4>
            </div>
          ) : null}
          {!_.isEmpty(items) ? (

            <div style={{ padding: 5, backgroundColor: '#f1f1f1', borderRadius: 10 }}>
              <InfoSection
                title="modifyUserTagWarning"
                gravity="warning"
                titleStyle={{ fontWeight: 'normal' }}
              />
              <div style={{ maxHeight: 400, padding: 5, overflowY: 'scroll' }}>
                <InfiniteScroll
                  pageStart={0}
                  useWindow={false}
                  initialLoad={false}
                  loadMore={() => onFetchMoreItems(pagination.number + 1)}
                  hasMore={pagination.number + 1 < pagination.totalPages}
                  loader={<ListLoadingView containerStyle={{ backgroundColor: 'transparent' }} />}
                >
                  <div style={{ paddingTop: 5, paddingBottom: 5 }}>
                    {_.map(items, (item, index) => (
                      <div key={item.id}>
                        {rowElement(item, index)}
                      </div>
                    ))}
                    
                  </div>
                </InfiniteScroll>
              </div>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <GuestGroupIcon style={{ color: '#3f3f3f', marginTop: 3, fontSize: 35 }} />
              <h4 style={{ color: '#3f3f3f', textAlign: 'center' }}>
                <Entity key={canAddGuests} entity={canAddGuests ? 'noGuestsInTag' : 'createTagToAssignGuests'} />
              </h4>
            </div>
          )}
        </FormFlatContainer>
      </Form>
    );
  }
} 

export default TagGuestsForm;